import axiosRequest from './restapi';

export const getNotifications = (userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: '/users/notifications',
    },
    userToken
  );
};

export const markNotificationsAsRead = (userToken: string, data: { ids: number[] }) => {
  return axiosRequest(
    {
      method: 'post',
      url: '/users/notifications/mark-as-read',
      data,
    },
    userToken
  );
};
